import { verifyMailService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    verification: [
        {
            first_name: '',
            verified: false
        }
    ]
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, verification) {
        state.status    = 'success'
        state.verification = verification
    }
}

const getters = {
    status: state => state.status,
    verification: state => state.verification
}

const actions = {
    verify({commit}, tracking_code) {
        commit('loading')
        return verifyMailService.verify(tracking_code).then(response => {
            commit('success', response.data.data)
        })
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}